// extracted by mini-css-extract-plugin
export default {"ErrorPage":"Main_ErrorPage__2748k"};